import { MdCallMade } from "react-icons/md";

function ServiceCard({ title, category, image, className }) {
  return (
    <div className={`service-card ${className}`} style={{ backgroundImage: `url(${image})` }}>
      <div className="service-card-info">
        <div className="service-card-text">
          <h3>{title}</h3>
          <span className="service-category">{category}</span>
        </div>
        <div className="service-card-icon">
          <MdCallMade />
        </div>
      </div>
    </div>
  );
}

export default ServiceCard;
